import reducer, { name } from './module';

export * from './module';
export * from './utils';

export default { reducer, name };
